module.exports = __webpack_public_path__ + "img/no-smoke-symbol.74436c49.svg";